import { dataLayer } from 'analytics/data-layer';
import { EventType, sendAdTechEvent } from './gtmServerFunctions';

export const promoNames = ['citrusAd', 'kevel'] as const;

export type PromoImpression = {
  id?: string;
  name?: (typeof promoNames)[number];
  position?: string;
  products?: {
    id: string;
  }[];
  urls?: string[];
  vendor?: string;
};

export const isPromoImpressionName = (value: unknown): value is (typeof promoNames)[number] => {
  return promoNames.includes(value as (typeof promoNames)[number]);
};

export default function promoImpression({
  id,
  name,
  position,
  products,
  urls,
  vendor,
}: PromoImpression) {
  sendAdTechEvent({
    eventType: EventType.IMPRESSION,
    sponsorshipId: id,
    trackingUrls: urls,
    vendor,
  });
  dataLayer.push({
    event: 'promo_impression',
    ecommerce: {
      promoView: {
        products,
        promotions: [
          {
            id,
            name,
            position,
          },
        ],
      },
    },
  });
}
